import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-14" }
const _hoisted_2 = { class: "text-gray-500 font-semibold p-4" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<ul class=\"controls w-full flex flex-row justify-between absolute top-[50%]\"><li class=\"prev rotate-180 z-10 flex flex-col items-center justify-center h-[60px] rounded-l px-2 bg-white laptop:hover:px-4 text-gray-500 hover:text-black transition-all hover:cursor-pointer\"><span class=\"material-symbols-outlined\">arrow_forward_ios</span></li><li class=\"next z-10 flex flex-col items-center justify-center h-[60px] rounded-l px-2 bg-white laptop:hover:px-4 text-gray-500 hover:text-black transition-all hover:cursor-pointer\"><span class=\"material-symbols-outlined\">arrow_forward_ios</span></li></ul>", 1)
const _hoisted_5 = { class: "my-slider" }
const _hoisted_6 = ["src"]

import {tns} from "tiny-slider"
  import {onMounted} from "vue";
  import {pictures, carouselHeading} from "../../../public/data/carousel";

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {
    var slider = tns({
      "container": ".my-slider",
      "items": 9,
      "mouseDrag": true,
      "swipeAngle": false,
      "speed": 400,
      "gutter": 10,
      "autoWidth": true,
      "slideBy": 1,
      "controlsContainer": ".controls",
      "nav": false,
      "touch": true,
    });
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(carouselHeading)), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pictures), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.image
          }, [
            _createElementVNode("img", {
              src: 'obrazky/carousel/' + item.image,
              alt: "ahoj",
              class: "h-[300px] laptop:h-[400px]"
            }, null, 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})